import React from "react";
import { Navigate, useLocation } from "react-router";
import { useEmpresaSession } from "../../auth/hooks/useEmpresaSession";
import { getEmpresaToken, getEmpresaUser } from "../../auth/api/empresaApi";

const BASE = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

type PrivateRouteBusinessProps = {
  children: React.ReactNode;
};

export default function PrivateRouteBusiness({
  children,
}: PrivateRouteBusinessProps) {
  const session = useEmpresaSession();
  const location = useLocation();
  const { isEmpresaLoggedIn } = session;
  const tokenFromStorage = getEmpresaToken();
  const userFromStorage = getEmpresaUser();

  const pathname = location.pathname;
  const isPublicEmpresaRoute =
    /\/empresa\/?$/.test(pathname) || /\/empresa\/login\/?$/.test(pathname);

  console.log("[PrivateRouteBusiness]", {
    pathname,
    isEmpresaLoggedIn,
    isPublicEmpresaRoute,
    hasUserStore: !!session.empresaUser,
    hasTokenStorage: !!tokenFromStorage,
    hasUserStorage: !!userFromStorage,
    BASE,
    redirectTo: `${BASE}/empresa/login`,
  });

  if (!isPublicEmpresaRoute && !isEmpresaLoggedIn) {
    console.log("[PrivateRouteBusiness] REDIRECTING to login (not logged in)");
    return (
      <Navigate
        to={`${BASE}/empresa/login`}
        state={{ from: location }}
        replace
      />
    );
  }
  console.log("[PrivateRouteBusiness] OK, rendering children");
  return <>{children}</>;
}
